import { EmeraldDialogTypes } from '../../common/enumerations/emerald-dialog-types';
import { store } from '../../common/redux/configure-store';
import { EpsData } from 'src/devices/payment/dtos/eps-data';
import { NCRBaseButtonProps } from 'src/common/components/base-button/base-button';
import { clearModals } from '@ncr-retail/base-retail-components';
import {
  buildEmeraldModalProps,
  EmeraldDialogProps,
  showEmeraldDialog,
} from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import { IModal } from 'src/common/components/interactive-dialogue/components/interactive-dialogue-container';

export const validateCard = async (epsData?: EpsData): Promise<boolean> => {
  if (!epsData) {
    return false;
  }
  if (!store.getState().touchPoint.touchPointConfiguration.paymentCardConfirmationRequired) {
    return true;
  }
  return new Promise<boolean>(resolve => {
    const declineButton: NCRBaseButtonProps = {
      'data-testid': 'dialog-messages-close',
      buttonType: 'white',
      onClick: () => {
        resolve(false);
        clearModals();
      },
      children: 'No',
    };

    const acceptButton: NCRBaseButtonProps = {
      'data-testid': 'dialog-messages-accept',
      buttonType: 'primary',
      onClick: () => {
        resolve(true);
        clearModals();
      },
      children: 'Yes',
    };

    const dialogProps: EmeraldDialogProps = {
      message: 'EpsCard_UseStoreCardCaption',
      type: EmeraldDialogTypes.Info,
      subMessage: 'EpsCard_UseStoreCardMessage',
      subMessageArgs: { arg: epsData.card.cardName || '' },
    };

    const modalProps: IModal = {
      open: true,
      rightButtons: [declineButton, acceptButton],
    };

    showEmeraldDialog(buildEmeraldModalProps(dialogProps, modalProps));
  });
};
